<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-16 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-28 11:40:21
 * @FilePath: 
 * @Description: 商品列表卡片展示组件
-->
<template>
  <div class="goods_card_list">
    <ul>
      <li v-for="(cartItem, id) in carGoodsList" :key="id" class="card_list_li">
        <div
          :class="handleSetTypeTitleClass(cartItem.name)"
          v-if="showFoodType"
        >
          <p class="user_name_con">{{ cartItem.name }}</p>
        </div>
        <!-- <p class="user_name_con" v-if="showFoodType">
          {{ cartItem.name }}
        </p> -->
        <ul class="card_list_group">
          <li
            v-for="(item, index) in cartItem.list"
            :key="index"
            :class="!isChangeNum || noRemarkModal ? 'van-hairline--bottom' : ''"
          >
            <van-card
              :desc="handleSetDesc(item)"
              :title="item.GoodsName"
              :thumb="item.PicUrl ? item.PicUrl : $root.defaultImg"
              :num="item.num"
              @click.stop="handleShowRemarkInput(id, item)"
            >
              <template #title>
                <van-row type="flex" justify="space-between" gutter="20">
                  <p>{{ item.GoodsName }}</p>
                  <p class="c-orange" v-if="showFoodType">￥{{ item.Price }}</p>
                  <p class="remark-p" v-if="item.remark">备注：{{item.remark}}</p>

                </van-row>
              </template>
             
              <template #price v-if="isChangeNum && !showFoodType">
                <p class="c-orange">￥{{ item.Price }}</p>
              </template>

              <!-- 定义数量展示的插槽 并将item传入父组件 -->
              <template v-if="isChangeNum" #num>
                <slot v-bind:goodsItem="item"></slot>
              </template>
              <template #tags v-if="item.mealNameStr">
                <slot name="mealName" v-bind:goodsItem="item"></slot>
              </template>
            </van-card>
             <div v-if="item.MenuGoods&&item.MenuGoods.length>0">
             
                  <div v-for="(child, j) in item.MenuGoods" :key ="child.GoodsId" >
                  <p>{{ child.GoodsName    }} x {{ (child.NumberCount||1)* item.num   }}</p>
                  </div>

             </div>
          </li>
        </ul>

        <van-row v-if="showFoodType" type="flex" justify="end">
          <p class="small_price_con c-lightgrey">
            {{ cartItem.smallNum }}份餐品 <span class="c-main-txt">小计：</span
            ><i class="c-orange">￥{{ cartItem.smallPrice }}</i>
          </p>
        </van-row>
      </li>
    </ul>
    <van-row v-if="showFoodType" type="flex" justify="end">
      <p class="small_price_con c-lightgrey">
        共{{ allNum }}份餐品 <span class="c-main-txt">合计：</span
        ><i class="c-orange">￥{{ allPrice }}</i>
      </p>
    </van-row>
    <van-popup v-model="showRemark" round closeable>
      <div class="input_remark_con">
        <p class="m-tb-20">请填写您的备注</p>
        <van-field
          v-model="orderRemark"
          rows="4"
          autosize
          label=""
          type="textarea"
          maxlength="100"
          placeholder="请填写备注"
        />
        <van-button
          class="m-tb-20"
          color="#333"
          round
          block
          @click="handleSubmitRemark"
          >确定</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "GoodsListCard",
  props: {
    isChangeNum: {
      //是否修改num区域展示内容
      type: Boolean,
      default: false,
    },
    showFoodType: {
      //是否展示餐品类型
      type: Boolean,
      default: false,
    },
    noRemarkModal: {
      //是否展示备注弹窗
      type: Boolean,
      default: false,
    },
    carGoodsList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    allNum: {
      type: Number,
      default: 0,
    },
    allPrice: {
      type: Number,
      default: 0,
    },
    isUseMemberPrice: {
      //是否展示会员价
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderRemark: "",
      showRemark: false,
    };
  },
  created() {},
  methods: {
    handleSetTypeTitleClass(name) {
      return name.indexOf("下单时间") != -1
        ? "time_type_con"
        : "goods_title_con";
    },
    handleSetDesc(item) {
      let RemarkStr = item.Remark || "";
      RemarkStr = item.CustomRemark
        ? RemarkStr + " " + item.CustomRemark
        : RemarkStr;

      return RemarkStr;
    },
    handleShowRemarkInput(id, item) {
      if ((this.isChangeNum && !this.showFoodType) || this.noRemarkModal)
        return;
      this.showRemark = true;
      this.orderRemark = item.CustomRemark;
      this.remarkItem = item;
    },
    handleSubmitRemark() {

      this.$set(this.remarkItem, "CustomRemark", this.orderRemark);
      this.showRemark = false;
      this.orderRemark = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.goods_card_list {
  @include white-box-radius(20px 0);

  .card_list_li {
    .goods_title_con {
      display: flex;
      justify-content: center;
      .user_name_con {
        // padding: 20px 0;
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 30px;
        font-size: 26px;
        color: #333;
        font-weight: bold;
        .van-icon {
          margin-right: 10px;
        }
        &::before {
          content: " ";
          position: absolute;
          width: 14px;
          height: 1px;
          top: 13px;
          left: -30px;
          border-radius: 50%;
          background-color: #333;
        }
        &::after {
          content: "";
          position: absolute;
          width: 14px;
          height: 1px;
          top: 13px;
          right: -30px;
          border-radius: 50%;
          background-color: #333;
        }
      }
    }

    .time_type_con {
      .user_name_con {
        color: #999;
        padding-bottom: 20px;
        margin: 0 25px;
        font-size: 26px;
        // position: relative;

        // &::after {
        //   position: absolute;
        //   box-sizing: border-box;
        //   content: " ";
        //   pointer-events: none;
        //   top: -50%;
        //   right: -50%;
        //   bottom: -50%;
        //   left: -50%;
        //   border: 0 solid #ebedf0;
        //   transform: scale(0.5);
        //   border-bottom-width: 1px;
        // }
      }
    }
    .card_list_group {
      padding: 0 25px;
      .van-card {
        padding: 10px 0;
      }
      .meal_desc_con {
        display: flex;
        align-items: center;
        margin: 10px 0;
        p {
          flex: 1;
          font-size: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        img {
          width: 20px;
          height: 20px;
        }
        background: #ebedf0;

        padding: 6px 8px;
        border-radius: 3px;
      }
    }
  }
  .small_price_con {
    padding: 20px 30px;
    font-size: 24px;
  }
}
.input_remark_con {
  padding: 24px;
  width: 80vw;
}
.remark-p{
color: #999;
width: 100%;
margin-top: 10px;
height:auto;
margin-right: 170px;
}
</style>
